import { PRICE_MODE_DEFAULT, PRICE_MODE_STARTING_FROM } from '@bluheadless/ui-logic/src/constants'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import Price from '../price'

export const useProductPriceProps = (props) => {
	const {
		price: { modeDefault, modeTiles },
	} = useConfig()

	let modeConfig

	switch (props?.displayContext) {
		case 'tiles':
			modeConfig = modeTiles
			break
		default:
			modeConfig = modeDefault
			break
	}

	const [
		{
			product: { type },
			prices,
			priceMode: priceModeContext,
		},
	] = useProductContext()

	const priceMode = priceModeContext ?? modeConfig?.[type] ?? PRICE_MODE_DEFAULT
	const amount = priceMode === PRICE_MODE_DEFAULT || priceMode === PRICE_MODE_STARTING_FROM ? prices.base : prices.min
	const specialAmount =
		priceMode === PRICE_MODE_DEFAULT || priceMode === PRICE_MODE_STARTING_FROM ? prices.final : prices.max
	const middlePrice = priceMode === PRICE_MODE_DEFAULT || priceMode === PRICE_MODE_STARTING_FROM ? prices.middle : null
	const oldPrice = priceMode === PRICE_MODE_DEFAULT || priceMode === PRICE_MODE_STARTING_FROM ? prices.old : null

	return { mode: priceMode, amount, specialAmount, hide: prices.hide, middlePrice, oldPrice, ...props }
}

const ProductPrice = ({ displayContext = 'default', ...props }) => {
	const { hide, ...productProps } = useProductPriceProps({ displayContext, ...props })

	return hide ? null : <Price {...productProps} />
}

export default ProductPrice
